import React, { useState } from "react";
import "./Header.css";
import { BiMenuAltRight } from "react-icons/bi";
import useOutsideClick from "../../hooks/useOutsideClick"; // custom hook

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const menuRef = useOutsideClick(() => setMenuOpened(false)); // handle outside click

  const getMenuStyles = (menuOpened) => {
    if (document.documentElement.clientWidth <= 800) {
      return { right: !menuOpened ? "-100%" : "0" };
    }
    return {};
  };

  return (
    <section className="h-wrapper">
      <div className="flexCenter paddings innerWidth h-container">
        <span className="flexCenter h-logo-text">
          BlueCraft
          <em>
            <img src="./Title-Icon.png" alt="Em-Logo" width={20} />
          </em>
        </span>

        <div
          ref={menuRef}
          className="flexCenter h-menu"
          style={getMenuStyles(menuOpened)}
        >
          <a href="/">Residencies</a>
          <a href="/">Our Value</a>
          <a href="/">Contact Us</a>
          <a href="/">Get Started</a>
          <button className="button">
            <a href="/">Contact</a>
          </button>
        </div>

        <div
          className="menu-icon"
          onClick={() => setMenuOpened((prev) => !prev)}
        >
          <BiMenuAltRight size={30} />
        </div>
      </div>
    </section>
  );
};

export default Header;
